import utils from 'utils/Utils';
export const getNextStep = (steps, stepsOrder) => {
    return utils.sortByArrayOfIds(steps, stepsOrder.map(Number))?.find(step => !step.isCompleted);
}
